// External deps
import { useState, useEffect } from 'react';
import { Navbar } from 'ypf-pas-general-ui-components';

// Internal deps
import { useAppContext } from '../../context/AppProvider';
import { MYROLS } from '../../services/yclickMaster';
import { postStartChatbotRound, postChatbotQuestion } from '../../services/administrationMaster';
import { getUrlWithSessionCreds } from '../../utils/globalFunctions';
import { useWorkReportModals } from '../../context/WorkReportModalsContext';
import './NavBar.scss';
import StatusReferenceModal from '../WorkReportModals/StatusReferenceModal/StatusReferenceModal';

import { getAllowedLinks } from './utils';

const NavBar = () => {
  const [rolUser, setRolUser] = useState(null);
  const [yClickLinks, setYClickLinks] = useState([]);
  const [idChat, setIdChat] = useState(null);
  const roles = JSON.parse(sessionStorage.getItem(MYROLS));

  const { userInfo, handleLogout, auth, isReady } = useAppContext();
  const { activeStatusReference, showModal, hideModal } = useWorkReportModals();

  // callback a chatbot
  const postMessage = async (message) => {
    const msg = { question: message };
    const isFirstChat = !idChat;

    return new Promise((resolve, reject) => {
      const promise = !isFirstChat ? postChatbotQuestion(msg, idChat) : postStartChatbotRound(msg);

      promise
        .then(({ data }) => {
          if (isFirstChat) {
            setIdChat(data.chatId);
          }
          resolve({ message: data.response });
        })
        .catch((err) => reject(err));
    });
  };

  useEffect(() => {
    if (auth || isReady) {
      setYClickLinks(getAllowedLinks(JSON.parse(sessionStorage.getItem(MYROLS))));
    }
  }, [auth, isReady]);

  useEffect(() => {
    if (roles && !rolUser) {
      setRolUser(roles.map((role) => role.nombre.substring(8)));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [roles]);

  return (
    <>
      <Navbar
        chatbotPostMessage={postMessage}
        chatbotTyC={getUrlWithSessionCreds('/termsofservice')}
        colorLineMenu="violet"
        expand="lg"
        logoYclickActive
        manyUserRoles={rolUser}
        onLogOut={handleLogout}
        openModalReference={activeStatusReference}
        showButtonHelp
        showChatbot
        titleYClickLinks="Gestión de Servicios"
        user={userInfo}
        yClickLinks={yClickLinks}
      />
      <StatusReferenceModal onHide={hideModal} show={showModal.statusReferenceModal} />
    </>
  );
};

export default NavBar;
